import { UniformLayout } from '../../types/layout';

const packedLayout: (
  edgeLength: number,
  count: number,
  containingHeight: number,
  containingWidth: number,
  padding?: number,
) => UniformLayout = (edgeLength, count, height, width, padding = 0) => {
  const columnCount = Math.floor(width / edgeLength);
  const rowCount = Math.ceil(count / columnCount);
  const paddedEdge = edgeLength;
  edgeLength = paddedEdge - padding * 2;

  const layout = (index: number) => {
    const row = index % rowCount;
    const column = Math.floor(index / rowCount);

    return {
      x: column * paddedEdge + padding,
      y: row * paddedEdge + padding,
      height: edgeLength,
      width: edgeLength,
    };
  };

  Object.assign(layout, {
    height,
    width,
    memberHeight: paddedEdge,
    memberWidth: paddedEdge,
  });

  return layout as UniformLayout;
};

export default packedLayout;
